module.exports = __webpack_public_path__ + "5b47fda3a5244008d87367990ef19a2a.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/manage-group/accounts/import/import-accounts-to-group.html
// module id = 2051
// module chunks = 0